// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as Accordion$OrcaPaymentPage from "./Accordion.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./PaymentElementShimmer.bs.js";

function AccordionContainer$Loader(props) {
  var cardShimmerCount = props.cardShimmerCount;
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match$1.layout);
  if (typeof paymentMethodList !== "object" && paymentMethodList === "SemiLoaded") {
    return Core__Array.make(cardShimmerCount - 1 | 0, "").map(function (param, i) {
                var borderStyle = layoutClass.spacedAccordionItems ? themeObj.borderRadius : (
                    i === (cardShimmerCount - 2 | 0) ? "0px 0px " + themeObj.borderRadius + " " + themeObj.borderRadius : ""
                  );
                return React.createElement("div", {
                            key: i.toString(),
                            className: "AccordionItem flex flex-row gap-3 animate-pulse cursor-default place-items-center",
                            style: {
                              border: "1px solid " + themeObj.borderColor,
                              borderTopStyle: i === 0 && !layoutClass.spacedAccordionItems ? "hidden" : "solid",
                              borderBottomStyle: i === (cardShimmerCount - 2 | 0) && !layoutClass.spacedAccordionItems || layoutClass.spacedAccordionItems ? "solid" : "hidden",
                              cursor: "pointer",
                              marginBottom: layoutClass.spacedAccordionItems ? themeObj.spacingAccordionItem : "",
                              minHeight: "60px",
                              minWidth: "80px",
                              width: "100%",
                              borderRadius: borderStyle,
                              overflowWrap: "hidden"
                            }
                          }, React.createElement(PaymentElementShimmer$OrcaPaymentPage.Shimmer.make, {
                                children: React.createElement("div", {
                                      className: "w-full h-full animate-pulse",
                                      style: {
                                        backgroundColor: themeObj.colorPrimary,
                                        opacity: "10%"
                                      }
                                    }),
                                classname: "opacity-50 h-5 w-[10%] rounded-full"
                              }), React.createElement(PaymentElementShimmer$OrcaPaymentPage.Shimmer.make, {
                                children: React.createElement("div", {
                                      className: "w-full h-full animate-pulse",
                                      style: {
                                        backgroundColor: themeObj.colorPrimary,
                                        opacity: "10%"
                                      }
                                    }),
                                classname: "opacity-50 h-2 w-[30%] rounded-full"
                              }));
              });
  } else {
    return null;
  }
}

var Loader = {
  make: AccordionContainer$Loader
};

function AccordionContainer(props) {
  var checkoutEle = props.checkoutEle;
  var paymentOptions = props.paymentOptions;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match$1.layout);
  var match$2 = React.useState(function () {
        return false;
      });
  var setShowMore = match$2[1];
  var showMore = match$2[0];
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var setSelectedOption = match$3[1];
  var selectedOption = match$3[0];
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var match$4 = layoutClass.savedMethodCustomization.groupingBehavior;
  var groupSavedMethodsSeparately = !match$4.displayInSeparateScreen && !match$4.groupByPaymentMethods;
  PaymentUtils$OrcaPaymentPage.useEmitPaymentMethodInfo(selectedOption, paymentMethodListValue.payment_methods, props.cardProps, props.expiryProps, props.cvcProps);
  var cardOptionDetails = PaymentMethodsRecord$OrcaPaymentPage.getPaymentDetails(paymentOptions, localeString).slice(0, layoutClass.maxAccordionItems);
  var dropDownOptionsDetails = PaymentMethodsRecord$OrcaPaymentPage.getPaymentDetails(paymentOptions, localeString).slice(layoutClass.maxAccordionItems);
  var getBorderRadiusStyleForCardOptionDetails = function (index) {
    if (!showMore && !layoutClass.spacedAccordionItems && index === 0 && paymentMethodList === "SemiLoaded" && cardOptionDetails.length === 1) {
      return themeObj.borderRadius + " " + themeObj.borderRadius + " 0px 0px";
    } else if (!showMore && !layoutClass.spacedAccordionItems && index === 0 && cardOptionDetails.length === 1) {
      return themeObj.borderRadius;
    } else if (!showMore && !layoutClass.spacedAccordionItems && index === (cardOptionDetails.length - 1 | 0)) {
      return "0px 0px " + themeObj.borderRadius + " " + themeObj.borderRadius;
    } else if (!layoutClass.spacedAccordionItems && index === 0) {
      return themeObj.borderRadius + " " + themeObj.borderRadius + " 0px 0px";
    } else if (layoutClass.spacedAccordionItems) {
      return themeObj.borderRadius;
    } else {
      return "0px";
    }
  };
  var getBorderRadiusStyleForDropDownOptionDetails = function (index) {
    if (!layoutClass.spacedAccordionItems && index === (dropDownOptionsDetails.length - 1 | 0)) {
      return "0px 0px " + themeObj.borderRadius + " " + themeObj.borderRadius;
    } else if (layoutClass.spacedAccordionItems) {
      return themeObj.borderRadius;
    } else {
      return "0px";
    }
  };
  React.useEffect((function () {
          var shouldAutoOpenSavedMethods = !layoutClass.savedMethodCustomization.defaultCollapsed && groupSavedMethodsSeparately && paymentOptions.includes("saved_methods");
          if (layoutClass.defaultCollapsed) {
            setSelectedOption(function (param) {
                  if (shouldAutoOpenSavedMethods) {
                    return "saved_methods";
                  } else {
                    return "";
                  }
                });
          }
          
        }), []);
  return React.createElement("div", {
              className: "w-full"
            }, React.createElement("div", {
                  className: "AccordionContainer flex flex-col overflow-auto no-scrollbar",
                  style: {
                    marginTop: themeObj.spacingAccordionItem,
                    marginBottom: themeObj.spacingAccordionItem,
                    width: "-webkit-fill-available"
                  }
                }, cardOptionDetails.map(function (payOption, i) {
                      var isActive = payOption.paymentMethodName === selectedOption;
                      var borderRadiusStyle = getBorderRadiusStyleForCardOptionDetails(i);
                      return JsxPPXReactSupportU.createElementWithKey(i.toString(), Accordion$OrcaPaymentPage.make, {
                                  paymentOption: payOption,
                                  isActive: isActive,
                                  checkoutEle: checkoutEle,
                                  borderBottom: !showMore && i === (cardOptionDetails.length - 1 | 0) && !layoutClass.spacedAccordionItems || layoutClass.spacedAccordionItems,
                                  borderRadiusStyle: borderRadiusStyle
                                });
                    }), React.createElement(AccordionContainer$Loader, {
                      cardShimmerCount: layoutClass.maxAccordionItems
                    }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                      condition: showMore,
                      children: dropDownOptionsDetails.map(function (payOption, i) {
                            var isActive = payOption.paymentMethodName === selectedOption;
                            var borderRadiusStyle = getBorderRadiusStyleForDropDownOptionDetails(i);
                            return JsxPPXReactSupportU.createElementWithKey(i.toString(), Accordion$OrcaPaymentPage.make, {
                                        paymentOption: payOption,
                                        isActive: isActive,
                                        checkoutEle: checkoutEle,
                                        borderBottom: i === (dropDownOptionsDetails.length - 1 | 0) && !layoutClass.spacedAccordionItems || layoutClass.spacedAccordionItems,
                                        borderRadiusStyle: borderRadiusStyle
                                      });
                          })
                    })), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: !showMore && dropDownOptionsDetails.length > 0,
                  children: React.createElement("button", {
                        className: "AccordionMore flex overflow-auto no-scrollbar",
                        style: {
                          cursor: "pointer",
                          marginTop: themeObj.spacingUnit,
                          minHeight: "60px",
                          minWidth: "150px",
                          padding: "20px",
                          width: "100%",
                          borderRadius: themeObj.borderRadius,
                          columnGap: themeObj.spacingUnit
                        },
                        onClick: (function (param) {
                            setShowMore(function (param) {
                                  return !showMore;
                                });
                          })
                      }, React.createElement("div", {
                            className: "flex flex-row",
                            style: {
                              columnGap: themeObj.spacingUnit
                            }
                          }, React.createElement("div", {
                                className: "m-2"
                              }, React.createElement(Icon$OrcaPaymentPage.make, {
                                    name: "arrow-down",
                                    size: 10
                                  })), React.createElement("div", {
                                className: "AccordionItemLabel"
                              }, "More")))
                }));
}

var make = AccordionContainer;

export {
  Loader ,
  make ,
}
/* react Not a pure module */
